// O que a gravação de sessão (session replay) do PostHog pode levar do navegador. Com tudo
// mascarado não dava para depurar nada, então o texto da interface sai legível e só o dado pessoal
// vai mascarado:
// - todo texto dentro de [data-ph-mask] ou .ph-mask (nome, endereço, observação do hóspede);
// - em qualquer texto, e-mail e sequência de 8 ou mais dígitos (CPF, CNPJ, telefone, cartão, RG);
// - todo campo de digitação; só o valor de <select> sai, também sem e-mail e dígitos.
// Imagem e canvas viram um bloco do mesmo tamanho, e só sobram os atributos que desenham a página.
// Nome não tem formato: o que não estiver marcado com data-ph-mask sai legível. A máscara roda
// no navegador: o valor original nunca chega ao PostHog, e gravação já feita não volta atrás.
//
// Chega pelo page_context.js antes do init (posthog_init.js), como o posthog_before_send.js. Por
// isso é ES5 puro e não depende de nada.
(function (window) {
  // Contêineres de dado pessoal: o texto dentro deles sai todo mascarado. Tela nova marca o elemento
  // com data-ph-mask; a lista abaixo cobre o que já existia e tem classe própria, para não mexer
  // em cada view. Editor de texto rico e textarea guardam o que a pessoa digitou, como um campo.
  var MASKED = [
    "[data-ph-mask]",
    ".ph-mask",
    "textarea",
    '[contenteditable]:not([contenteditable="false"])',
    // Vão para o <body> ao abrir: popover e tooltip (nome, observação, antes/depois de auditoria,
    // titular do cartão) e a lista do select2 (hóspede, empresa, usuário).
    ".popover",
    ".tooltip",
    ".audit-popover",
    ".select2-container",
    ".select2-dropdown",
    // Ficha impressa da reserva e do hóspede (ficam no DOM, escondidas na tela).
    ".sheet-form",
    ".d-print-block",
    // Colunas da lista de hóspedes e de empresas (check_column).
    "td.name",
    "td.email",
    "td.ssn",
    "td.identification",
    "td.passport",
    "td.birth",
    "td.company_id",
    "td.occupation",
    "td.primary_phone",
    "td.extra_phone",
    "td.phone",
    "td.district",
    "td.zip_code",
    "td.city",
    "td.country",
    // Mapa de reservas, home, aniversariantes, lista de café e resumo do dia.
    ".Reservation__name",
    "p.guest",
    ".Popover__toggle__note",
    ".room-guest",
    ".td-guest-name",
    ".td-guest-age",
    ".td-guest-birth",
    ".td-guest-email",
    ".td-guest-phone",
    ".guest-name",
    ".guest-age",
    "td.col-320",
    // Atividades e auditoria: autor e registro alterado (o título é o nome do hóspede).
    ".list-group-item-heading",
    ".media-body .badge-secondary",
    // Reserva (React).
    ".reservation-edit-select",
    ".reservation-show__responsible-select",
    ".reservation-form-modal__field--responsible",
    ".reservation-show__company-tag",
    ".reservation-show__guest-name",
    ".reservation-show__payment-payer",
    ".reservation-show__payments-payers",
    ".reservation-show__bill-description",
    ".reservation-show__checkin-guest",
    ".reservation-show__checkin-guest-cell",
    ".reservation-show__guests-modal-options",
    ".reservation-show__guests-modal-td--name",
    ".reservation-show__guests-error",
    ".reservation-show__meta",
    // Motor de reservas: carrinho abandonado.
    ".be-abandoned-list__summary"
  ].join(", ");
  var EMAIL = /[^\s@<>()[\]"',;:]+@[^\s@<>()[\]"',;:]+/g;
  // Dígito, e entre dígitos até 3 separadores de documento e telefone. "/" fica fora para a data
  // (10/10/2026) não virar uma sequência só.
  var DIGITS = /\+?\d(?:[ .\-()]{0,3}\d)*/g;
  var MIN_DIGITS = 8;
  // Atributos que só desenham a página. Qualquer outro (title, alt, href, data-*, src) pode trazer
  // dado do hóspede e sai mascarado; placeholder, aria-label e value vão pelo UI_ATTRIBUTES.
  // Comparados em minúsculas.
  var LAYOUT_ATTRIBUTES = [
    "class",
    "id",
    "style",
    "type",
    "role",
    "rel",
    "media",
    "name",
    "for",
    "width",
    "height",
    "colspan",
    "rowspan",
    "dir",
    "lang",
    "tabindex",
    "hidden",
    "disabled",
    "aria-hidden",
    "aria-expanded",
    // Gerados pelo próprio gravador: CSS embutido das nossas folhas de estilo e medidas do
    // bloco que substitui elemento bloqueado. rr_dataURL (pixels) e rr_src (iframe) ficam fora.
    "_csstext",
    "rr_width",
    "rr_height",
    "rr_left",
    "rr_top",
    "rr_position",
    "rr_transform",
    "rr_display",
    "rr_scrollleft",
    "rr_scrolltop",
    "rr_mediastate",
    "rr_open_mode"
  ];
  // Texto de interface escrito no HTML, não pela pessoa: sai como o texto da página, sem e-mail e
  // dígitos. O title fica de fora: o tooltip do mapa e das listas mostra o nome do hóspede.
  var UI_ATTRIBUTES = ["placeholder", "aria-label", "value"];
  // Input cujo value é rótulo ou opção, não texto digitado.
  var LABEL_INPUTS = ["submit", "button", "reset", "radio", "checkbox"];
  // Foto de documento, assinatura, anexo e arquivo escolhido para upload. Campo oculto também:
  // o gravador não mascara o valor de input hidden/file, e aqui ele carrega id e dado de formulário.
  var BLOCKED =
    'img, picture, video, audio, canvas, iframe, object, embed, svg image, input[type="hidden"], input[type="file"]';
  // background-image inline pode apontar para o arquivo de um documento.
  var CSS_URL = /url\([^)]*\)/gi;

  function stars(text) {
    return text.replace(/\S/g, "*");
  }

  function scrub(text) {
    return String(text)
      .replace(EMAIL, stars)
      .replace(DIGITS, function (match) {
        return match.replace(/\D/g, "").length >= MIN_DIGITS ? match.replace(/\d/g, "*") : match;
      });
  }

  function insideMasked(element) {
    return !!(element && element.closest && element.closest(MASKED));
  }

  // maskTextSelector "*" faz todo texto passar por aqui; recebe o elemento pai do texto.
  function maskText(text, element) {
    return insideMasked(element) ? stars(text) : scrub(text);
  }

  // Recebe o valor de input, textarea e select. Só o select (status, categoria, forma de
  // pagamento) sai legível: nos outros, o valor é o que a pessoa digitou.
  function maskInput(text, element) {
    var tag = element && String(element.tagName).toLowerCase();
    if (tag !== "select" || insideMasked(element)) return new Array(String(text).length + 1).join("*");
    return scrub(text);
  }

  // O value de campo de texto chega aqui com o que veio do servidor (value="Maria") quando a pessoa
  // esvazia o campo: o gravador só troca pelo valor mascarado quando o campo tem valor.
  function typedValue(attribute, element) {
    if (attribute !== "value") return false;
    var tag = element ? String(element.tagName).toLowerCase() : "";
    if (tag === "textarea") return true;
    if (tag !== "input") return !element;
    var type = String(element.type || (element.getAttribute && element.getAttribute("type")) || "text");
    return LABEL_INPUTS.indexOf(type.toLowerCase()) === -1;
  }

  function withoutQuery(url) {
    return String(url).split(/[?#]/)[0];
  }

  function maskAttribute(name, value, element) {
    var attribute = String(name).toLowerCase();
    if (attribute === "style") return value.replace(CSS_URL, "none");
    // A folha de estilo já vai embutida em _cssText; o href fica só como referência.
    if (attribute === "href" && element && String(element.tagName).toLowerCase() === "link") return withoutQuery(value);
    if (LAYOUT_ATTRIBUTES.indexOf(attribute) !== -1) return value;
    if (UI_ATTRIBUTES.indexOf(attribute) !== -1 && !insideMasked(element) && !typedValue(attribute, element)) {
      return scrub(value);
    }
    return new Array(value.length + 1).join("*");
  }

  // Também recebe a URL da página que aparece no player ({ name }). A busca da navbar e os filtros
  // põem nome, e-mail e documento do hóspede na query string. Cabeçalho e corpo saem sempre, mesmo
  // que alguém ligue a captura de rede nas configurações do projeto.
  function maskRequest(request) {
    if (!request) return request;
    if (request.name) request.name = withoutQuery(request.name);
    delete request.requestHeaders;
    delete request.responseHeaders;
    delete request.requestBody;
    delete request.responseBody;
    return request;
  }

  window.posthogSessionRecording = function () {
    return {
      maskAllInputs: true,
      maskTextSelector: "*",
      maskTextFn: maskText,
      maskInputFn: maskInput,
      maskAttributeFn: maskAttribute,
      blockSelector: BLOCKED,
      captureCanvas: { recordCanvas: false },
      captureJsonLd: false,
      recordCrossOriginIframes: false,
      recordHeaders: false,
      recordBody: false,
      maskCapturedNetworkRequestFn: maskRequest
    };
  };
})(window);
